// accountIdentity — what the sidebar's account row shows, pure.
//
// The name is the author's display name when they set one, else their email.
// The initials come from that name: the first letters of its first two words
// ("Anna Lind" → "AL"); an email gives the first letter of its local part
// ("anna.lind@…" → "A"). Nothing usable (an empty or symbol-only name) falls
// back to a neutral "?", so the avatar never renders empty.

export { accountIdentityOf };

type AccountIdentity = {
    readonly name: string;
    readonly initials: string;
};

// The first letter (any script) of a word, upper-cased, or "" when none.
const firstLetter = (word: string): string =>
    (word.match(/\p{L}/u)?.[0] ?? "").toLocaleUpperCase();

const accountIdentityOf = (
    displayName: string,
    email: string,
): AccountIdentity => {
    const named = displayName.trim();
    if (named !== "") {
        const initials = named
            .split(/\s+/u)
            .slice(0, 2)
            .map(firstLetter)
            .join("");
        return { name: named, initials: initials === "" ? "?" : initials };
    }
    const local = email.split("@")[0] ?? "";
    const initial = firstLetter(local);
    return { name: email, initials: initial === "" ? "?" : initial };
};
